import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IIdentifiableEntity } from 'app/types/entity';

export interface IConfiguration extends IIdentifiableEntity {
}

export type Configuration = Entity<IConfiguration>;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Configuration: IEntityType<IConfiguration> = vmClient.defineClass({
  typeName: 'Configuration',
  version: 1,
  persisted: true,
});
